"use client";

import { Navbar, Dropdown, Avatar, Badge } from "flowbite-react";
import { Link, useNavigate } from "react-router-dom";
import { MdDashboard } from "react-icons/md";
import { Button } from "antd";
import AuthContext from "../../utils/AuthContext";
import { useContext, useState } from "react";
import { errorModal } from "../modals/ModalMessages";
import EventEmitter from "../../utils/eventEmitter";
import SalesDetailsModal from "../modals/SalesDetailsModal";
import { loadPosForSalesDetails } from "../apis/posSalesUpdateAPI";





const PosHeader = () => {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const [pos, setPos] = useState([]);
  const goToDashboard = () => navigate('/pos/dashboard');

  const checkAndProceed = (e) => {
    // e.preventDefault();
    if (user.access_right.pos_config_accountant === 0 && user.access_right.pos_config_cashier === 0) {
      errorModal('ACCESS DENIED!', 
        <div>
          <p>You don't have the access to daily sales record.</p>
          <p>Please, contact administration to grant you access</p>
        </div>
      )
    }else {
      navigate('/pos/sales-update');
    }
  }

  const openSalesDetails = async () => {
    try {
      const results = await loadPosForSalesDetails();
      if (results) {
        setPos(results);
        EventEmitter.dispatch('opensalesdetails', true);
      }
    }catch (err) {
      errorModal('OOPS! SOMETHING HAS HAPPENED', 
        <div>
          <p>There was an error requesting data. This can be due to bad network or server malfunction</p>
          <p>Please, check your network connection and try again.</p>
          <p>If problem still persist, contact the system's engineer</p>
          <p>Thank you.</p>
        </div>
      )
    }
  }

  return (
    <>
      <Navbar fluid rounded className="mb-3 border-b-2 py-1 pb-0 header">
        <div className="flex">
          <Link className="me-3 p-2 border-2 rounded hover:text-blue-500" to={'/'}>{<MdDashboard />}</Link>
          <Navbar.Brand as={Link} to={'/pos/'} className="w-50">
            <span className="self-center whitespace-nowrap text-xl font-semibold dark:text-white">Point of Sales</span>
          </Navbar.Brand>
        </div>
        <div className="flex">

          <Button type="text" className="me-2" onClick={goToDashboard}>Dashboard</Button>

          {/* <Dropdown arrowIcon={false} inline destroyPopupOnHide label="New Order"></Dropdown> */}

          <Dropdown arrowIcon={false} inline label={<span className="mx-2">Orders</span>}>
            <Dropdown.Item as={Link} to={'/pos/pos-orders'}>Orders</Dropdown.Item>
            <Dropdown.Item as={Link} to={'/pos/pos-sessions'}>Sessions</Dropdown.Item>
            <Dropdown.Item as={Link} to={'/pos/pos-pick-laters'}>Pick Later Orders</Dropdown.Item>
            <Dropdown.Item as={Link} to={'/pos/pos-payments'}>Payments</Dropdown.Item>
            <Dropdown.Item as={Link} to={'/pos/customers'}>Customers</Dropdown.Item>
          </Dropdown>


          <Dropdown arrowIcon={false} inline label={<span className="mx-2">Products</span>}>
            <Dropdown.Item as={Link} to={'/pos/products'}>Products</Dropdown.Item>
            {/* <Dropdown.Item as={Link} to={'/sales/packages'}>Product Variants</Dropdown.Item> */}
          </Dropdown>

          {user.access_right.pos_role &&
          <Dropdown arrowIcon={false} inline label={<span className="mx-2">Reporting</span>}>
            <Dropdown.Item onClick={checkAndProceed}>Sales Update</Dropdown.Item>
            {user.access_right.pos_config_accountant && <Dropdown.Item onClick={openSalesDetails}>Sales Details</Dropdown.Item>}
          </Dropdown>}

          {user.access_right.pos_role && user.access_right.pos_role.name === 'Administrator' &&
          <Dropdown arrowIcon={false} inline label={<span className="mx-2">Configurations</span>}>
            <Dropdown.Item as={Link} to={'/pos/settings'}>Settings</Dropdown.Item>
            <Badge className="text-slate-600 bg-transparent">Point of Sales</Badge>
            <Dropdown.Item as={Link} to={'/pos/point-of-sales'}>Point of Sales</Dropdown.Item>
            <Dropdown.Item as={Link} to={'/pos/delivery-regions'}>Delivery Regions</Dropdown.Item>
            <Dropdown.Item as={Link} to={'/pos/payment-methods'}>Payment Methods</Dropdown.Item>
          </Dropdown>}
        </div>
        <div className="">
          
          <Dropdown
            arrowIcon={false}
            inline
            label={
              <Avatar alt="User settings" img="https://flowbite.com/docs/images/people/profile-picture-5.jpg" rounded />
            }
          >
            <Dropdown.Header>
              <span className="block text-sm">Bonnie Green</span>
              <span className="block truncate text-sm font-medium">name@flowbite.com</span>
            </Dropdown.Header>
            <Dropdown.Item>Dashboard</Dropdown.Item>
            <Dropdown.Item>Settings</Dropdown.Item>
            <Dropdown.Item>Earnings</Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item>Sign out</Dropdown.Item>
          </Dropdown>
          {/* <Navbar.Toggle /> */}
        </div>
        {/* <Navbar.Collapse>
          <Navbar.Link href="#" active>
            Home
          </Navbar.Link>
          <Navbar.Link href="#">About</Navbar.Link>
          <Navbar.Link href="#">Services</Navbar.Link>
          <Navbar.Link href="#">Pricing</Navbar.Link>
          <Navbar.Link href="#">Contact</Navbar.Link>
        </Navbar.Collapse> */}
      </Navbar>
      <SalesDetailsModal data={pos}/>
    </>
  );
}




export default PosHeader;